export default "__VITE_ASSET__BPmwmMqW__"